/**
 * Shared category tree helpers (reporting, transaction filters, business expense scope).
 */

export interface CategoryTreeNode {
  id: string;
  parent_id?: string | null;
  parentId?: string | null;
}

function parentIdOf(category: CategoryTreeNode): string | null {
  return category.parent_id ?? category.parentId ?? null;
}

export function collectDescendantCategoryIds(
  rootId: string,
  categories: CategoryTreeNode[]
): Set<string> {
  const childrenByParent = new Map<string, string[]>();
  for (const c of categories) {
    const parentId = parentIdOf(c);
    if (!parentId) continue;
    const list = childrenByParent.get(parentId) ?? [];
    list.push(c.id);
    childrenByParent.set(parentId, list);
  }

  const ids = new Set<string>([rootId]);
  const queue = [rootId];
  while (queue.length) {
    const pid = queue.shift()!;
    for (const childId of childrenByParent.get(pid) ?? []) {
      if (!ids.has(childId)) {
        ids.add(childId);
        queue.push(childId);
      }
    }
  }
  return ids;
}

export function expandCategoryIdsToDescendants(
  categoryIds: string[],
  categories: CategoryTreeNode[]
): Set<string> {
  const expanded = new Set<string>();
  for (const id of categoryIds) {
    for (const descId of collectDescendantCategoryIds(id, categories)) {
      expanded.add(descId);
    }
  }
  return expanded;
}
